import {$events} from '../../helpers/events';
import {$dom} from '../../helpers/dom';
import variables from '../../variables';

const {
	exist,
	hasClass,
	getAll,
	attr
} = $dom;

export default function pageSwitcher(
	rootSelector = '.js-page-switch',
	checkboxSelector = '.js-page-switch-checkbox',
	buttonSelector = '.js-page-switch-button'
) {

	if (exist([checkboxSelector, buttonSelector])) {

		const {active} = variables.classNames;

		function navigate() {
			const
				root = this.closest(rootSelector),
				links = getAll(buttonSelector, root),
				notActiveLink = links.find(l => !hasClass(l, active))
			;

			location.href = attr(notActiveLink, 'href')
		}

		const
			init = () => $events.delegate.on('click tap', checkboxSelector, navigate),
			destroy = () => $events.delegate.off('click tap', checkboxSelector, navigate)
		;

		return {init, destroy}
	}

	return null
}
